import { appVersion } from './appVersion';

type Severity = 'debug' | 'log' | 'info' | 'warn' | 'error';

const logMessage = (severity: Severity, ...inputData: unknown[]) => {
  const prefix = `[${severity.toUpperCase()}] UserTenantOnboarding v${appVersion}`;
  console[severity](prefix, ...inputData);
};

export const Logger = {
  debug: (...inputData: unknown[]): void => logMessage('debug', ...inputData),
  log: (...inputData: unknown[]): void => logMessage('log', ...inputData),
  info: (...inputData: unknown[]): void => logMessage('info', ...inputData),
  warn: (...inputData: unknown[]): void => logMessage('warn', ...inputData),
  error: (...inputData: unknown[]): void => logMessage('error', ...inputData)
};
